angular.module("vgresiduos").directive("disposalResidues", function () {
	return {
		scope: true,
		controller: "DisposalResiduesCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalResidues/disposalResidues_template.html"
	};
});
